import { Box } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const InputGroup = ({ children }: Props) => {
  return (
    <Box display="flex" gap={1}>
      {children}
    </Box>
  );
};
